import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../utils/api';
import { toast } from 'react-toastify';

export const getAllBomOrderThunk = createAsyncThunk(
    'bom/getAllBomOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllbomOrder(config);
            //   console.log("nnnnn",response.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const getbomOrderStatisticsThunk = createAsyncThunk(
    'bom/getbomOrderStatisticsThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getBomOrderStatistics(config);
            //   console.log("staticssssssss",response.data?.data);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const bomOrderDetailsThunk = createAsyncThunk(
    'bom/bomOrderDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getbomOrderDetails(id);
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const exportbomOrderThunk = createAsyncThunk(
    'order/exportbomOrderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getAllbomOrder(config);
              console.log(response.data?.data);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const deletebomOrderThunk = createAsyncThunk(
    'order/deletebomOrderThunk',
    async (id, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteBomOrder(id);
            dispatch(setbomOrderrefresh())
            toast.success('bom enquiry deleted successfully')
            return response.data?.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to delete bom enquiry')
        }
    }
);


export const updateOrderStatus = createAsyncThunk(
    'order/updateStatus',
    async (data, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.updatebomOrderStatus(data);
            dispatch(setbomOrderrefresh())
            toast.success('order updated  successfully')
            return response.status;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'unable to update order')
        }
    }
);

const bomOrderSlice = createSlice({
    name: 'bomOrder',
    initialState: {
        bom:[],
        bomenquiry: [],
        orderDetails: {},
        orderStatistics: {
            data: {},
            loading: false
        },
        refresh: false,
        loading: false,
        exportLoading: false,
        error: null,
        selectedTab: 0,
        page: 1,
        search: '',
        status: '',
        fromDate: '',
        toDate: '',
    },
    reducers: {

        setbomOrderrefresh: (state, action) => {
            state.refresh = !state.refresh;
        },
        setbomOrderPage: (state, action) => {
            state.page = action.payload
        },
        setbomOrderSearch: (state, action) => {
            state.search = action.payload
        },
        setbomOrderStatus: (state, action) => {
            state.status = action.payload
        },
        setbomOrderFromDate: (state, action) => {
            state.fromDate = action.payload
        },
        setbomOrderToDate: (state, action) => {
            state.toDate = action.payload
        },
        setbomOrderSelectedTab: (state, action) => {
            state.selectedTab = action.payload
        },
        setbomOrderData: (state, action) => {
            state.orderDetails = {
                ...state.orderDetails, // Keep existing fields
                products: action.payload, // Update only products
            };
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllBomOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllBomOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.bom = action.payload;
            })
            .addCase(getAllBomOrderThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(bomOrderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(bomOrderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(bomOrderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            })

            //details
            .addCase(exportbomOrderThunk.pending, (state) => {
                state.exportLoading = true;
            })
            .addCase(exportbomOrderThunk.fulfilled, (state, action) => {
                state.exportLoading = false;
            })
            .addCase(exportbomOrderThunk.rejected, (state, action) => {
                state.exportLoading = false;
            })

            //statistics
            .addCase(getbomOrderStatisticsThunk.pending, (state) => {
                state.orderStatistics.loading = true;
            })
            .addCase(getbomOrderStatisticsThunk.fulfilled, (state, action) => {
                state.orderStatistics.loading = false;
                state.orderStatistics.data = action.payload
            })
            .addCase(getbomOrderStatisticsThunk.rejected, (state, action) => {
                state.orderStatistics.loading = false
            })
    },
});

export const { setbomOrderrefresh, setbomOrderPage, setbomOrderSearch, setbomOrderStatus, setbomOrderFromDate, setbomOrderToDate, setbomOrderSelectedTab, setbomOrderData } = bomOrderSlice.actions
export default bomOrderSlice.reducer;

